<!-- Messages toggle -->
<button (click)="toggleScheme()" mat-icon-button>
    <mat-icon [svgIcon]="'heroicons_solid:sun'"></mat-icon>
</button>

<button (click)="settingsDrawer.toggle()" *ngIf="false" mat-icon-button>
    <mat-icon [svgIcon]="'heroicons_solid:cog-8-tooth'"></mat-icon>
</button>

<fuse-drawer
    #settingsDrawer
    [mode]="'over'"
    [name]="'settingsDrawer'"
    [position]="'right'"
    class="z-999 w-100 min-w-100"
    fixed
>
    <div class="bg-card flex w-full flex-col overflow-auto">
        <div
                class="flex h-20 min-h-20 flex-row items-center bg-primary px-6 text-white"
        >
            <mat-icon
                    [svgIcon]="'heroicons_solid:cog-8-tooth'"
                    class="text-current icon-size-7"
            ></mat-icon>
            <div class="ml-3 text-2xl font-semibold tracking-tight">
                Settings
            </div>
            <button
                    (click)="settingsDrawer.close()"
                    class="ml-auto"
                    mat-icon-button
            >
                <mat-icon
                        [svgIcon]="'heroicons_outline:x-mark'"
                        class="text-current"
                ></mat-icon>
            </button>
        </div>

        <div class="flex flex-col p-6">
            <!-- Theme -->
            <div class="text-secondary text-md font-semibold">THEME</div>
            <div class="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3">
                @for (theme of config.themes; track theme) {
                    <div
                            class="bg-hover flex cursor-pointer items-center justify-center rounded-full px-4 py-3 ring-inset ring-primary"
                            [class.ring-2]="config.theme === theme.id"
                            [ngClass]="theme.id"
                            (click)="setTheme(theme.id)"
                    >
                        <div
                                class="h-3 w-3 flex-0 rounded-full bg-primary"
                        ></div>
                        <div
                                class="ml-2.5 truncate font-medium leading-5"
                                [class.text-secondary]="config.theme !== theme.id"
                        >
                            {{ theme.name }}
                        </div>
                    </div>
                }
            </div>

            <hr class="my-8"/>

            <!-- Scheme -->
            <div class="text-secondary text-md font-semibold">SCHEME</div>
            <div class="mt-6 grid grid-cols-3 justify-items-start gap-3">
                <!-- Auto -->
                <div
                        (click)="setScheme('auto')"
                        [class.ring-2]="config.scheme === 'auto'"
                        class="bg-hover flex cursor-pointer items-center rounded-full py-3 pl-5 pr-6 ring-inset ring-primary"
                        matTooltip="Automatically sets the scheme based on user's operating system's color scheme preference using 'prefer-color-scheme' media query."
                >
                    <div class="flex items-center overflow-hidden rounded-full">
                        <mat-icon
                                [svgIcon]="'heroicons_solid:bolt'"
                                class="icon-size-5"
                        ></mat-icon>
                    </div>
                    <div
                            [class.text-secondary]="config.scheme !== 'auto'"
                            class="ml-2 flex items-center font-medium leading-5"
                    >
                        Auto
                    </div>
                </div>
                <!-- Dark -->
                <div
                        (click)="setScheme('dark')"
                        [class.ring-2]="config.scheme === 'dark'"
                        class="bg-hover flex cursor-pointer items-center rounded-full py-3 pl-5 pr-6 ring-inset ring-primary"
                >
                    <div class="flex items-center overflow-hidden rounded-full">
                        <mat-icon
                                [svgIcon]="'heroicons_solid:moon'"
                                class="icon-size-5"
                        ></mat-icon>
                    </div>
                    <div
                            [class.text-secondary]="config.scheme !== 'dark'"
                            class="ml-2 flex items-center font-medium leading-5"
                    >
                        Dark
                    </div>
                </div>
                <!-- Light -->
                <div
                        (click)="setScheme('light')"
                        [class.ring-2]="config.scheme === 'light'"
                        class="bg-hover flex cursor-pointer items-center rounded-full py-3 pl-5 pr-6 ring-inset ring-primary"
                >
                    <div class="flex items-center overflow-hidden rounded-full">
                        <mat-icon
                                [svgIcon]="'heroicons_solid:sun'"
                                class="icon-size-5"
                        ></mat-icon>
                    </div>
                    <div
                            [class.text-secondary]="config.scheme !== 'light'"
                            class="ml-2 flex items-center font-medium leading-5"
                    >
                        Light
                    </div>
                </div>
            </div>

            <hr class="my-8"/>

            <!-- Layout -->
            <div class="text-secondary text-md font-semibold">
                Vertical Layout
            </div>
            <div class="mt-6 grid grid-cols-3 gap-3">
                <!-- Empty -->

                <!-- Classic -->
                <div
                        (click)="setLayout('classic')"
                        class="flex cursor-pointer flex-col"
                >
                    <div
                            [class.border-primary]="config.layout === 'classic'"
                            class="flex h-20 overflow-hidden rounded-md border-2 hover:opacity-80"
                    >
                        <div class="w-8 bg-gray-100 dark:bg-gray-800">
                            <div class="mx-1.5 mt-3 space-y-1">
                                <div
                                        class="h-1 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                            </div>
                        </div>
                        <div class="flex flex-auto flex-col border-l">
                            <div class="h-3 bg-gray-100 dark:bg-gray-800">
                                <div
                                        class="mr-1.5 flex h-full items-center justify-end"
                                >
                                    <div
                                            class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                    <div
                                            class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                    <div
                                            class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                </div>
                            </div>
                            <div
                                    class="flex flex-auto border-t bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                            [class.text-primary]="config.layout === 'classic'"
                            class="text-secondary mt-2 text-center text-md font-medium"
                    >
                        Classic
                    </div>
                </div>

                <!-- Classy -->
                <div
                        (click)="setLayout('classy')"
                        class="flex cursor-pointer flex-col"
                >
                    <div
                            [class.border-primary]="config.layout === 'classy'"
                            class="flex h-20 overflow-hidden rounded-md border-2 hover:opacity-80"
                    >
                        <div class="w-8 bg-gray-100 dark:bg-gray-800">
                            <div class="mx-1 mt-1 flex items-center">
                                <div
                                        class="h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="ml-auto h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="ml-0.5 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                            </div>
                            <div
                                    class="mx-auto mt-2.5 h-4 w-4 rounded-full bg-gray-300 dark:bg-gray-700"
                            ></div>
                            <div class="mx-1 mt-2 space-y-1">
                                <div
                                        class="h-1 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                            </div>
                        </div>
                        <div class="flex flex-auto flex-col border-l">
                            <div class="h-3 bg-gray-100 dark:bg-gray-800">
                                <div
                                        class="mr-2 flex h-full items-center justify-end"
                                >
                                    <div
                                            class="h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                </div>
                            </div>
                            <div
                                    class="flex flex-auto border-t bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                            [class.text-primary]="config.layout === 'classy'"
                            class="text-secondary mt-2 text-center text-md font-medium"
                    >
                        Classy
                    </div>
                </div>

                <!-- Compact -->
                <div
                        (click)="setLayout('compact')"
                        class="flex cursor-pointer flex-col"
                >
                    <div
                            [class.border-primary]="config.layout === 'compact'"
                            class="flex h-20 overflow-hidden rounded-md border-2 hover:opacity-80"
                    >
                        <div class="w-5 bg-gray-100 dark:bg-gray-800">
                            <div
                                    class="mx-auto mt-2 h-3 w-3 rounded-sm bg-gray-300 dark:bg-gray-700"
                            ></div>
                            <div
                                    class="mt-2 flex w-full flex-col items-center space-y-1"
                            >
                                <div
                                        class="h-2.5 w-3 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-2.5 w-3 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-2.5 w-3 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                            </div>
                        </div>
                        <div class="flex flex-auto flex-col border-l">
                            <div class="h-3 bg-gray-100 dark:bg-gray-800">
                                <div
                                        class="mr-1.5 flex h-full items-center justify-end"
                                >
                                    <div
                                            class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                    <div
                                            class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                    <div
                                            class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                </div>
                            </div>
                            <div
                                    class="flex flex-auto border-t bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                            [class.text-primary]="config.layout === 'compact'"
                            class="text-secondary mt-2 text-center text-md font-medium"
                    >
                        Compact
                    </div>
                </div>

                <!-- Dense -->
                <div
                        (click)="setLayout('dense')"
                        class="flex cursor-pointer flex-col"
                >
                    <div
                            [class.border-primary]="config.layout === 'dense'"
                            class="flex h-20 overflow-hidden rounded-md border-2 hover:opacity-80"
                    >
                        <div class="w-4 bg-gray-100 dark:bg-gray-800">
                            <div
                                    class="mx-auto mt-2 h-2 w-2 rounded-sm bg-gray-300 dark:bg-gray-700"
                            ></div>
                            <div
                                    class="mt-2 flex w-full flex-col items-center space-y-1"
                            >
                                <div
                                        class="h-2 w-2 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-2 w-2 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-2 w-2 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                            </div>
                        </div>
                        <div class="flex flex-auto flex-col border-l">
                            <div class="h-3 bg-gray-100 dark:bg-gray-800">
                                <div
                                        class="mr-1.5 flex h-full items-center justify-end"
                                >
                                    <div
                                            class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                    <div
                                            class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                    <div
                                            class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                </div>
                            </div>
                            <div
                                    class="flex flex-auto border-t bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                            [class.text-primary]="config.layout === 'dense'"
                            class="text-secondary mt-2 text-center text-md font-medium"
                    >
                        Dense
                    </div>
                </div>

                <!-- Futuristic -->
                <div
                        (click)="setLayout('futuristic')"
                        class="flex cursor-pointer flex-col"
                >
                    <div
                            [class.border-primary]="config.layout === 'futuristic'"
                            class="flex h-20 overflow-hidden rounded-md border-2 hover:opacity-80"
                    >
                        <div class="w-8 bg-gray-100 dark:bg-gray-800">
                            <div
                                    class="flex h-full flex-auto flex-col space-y-1 px-1.5 py-3"
                            >
                                <div
                                        class="h-1 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div class="flex-auto"></div>
                                <div
                                        class="h-1 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                            </div>
                        </div>
                        <div class="flex flex-auto flex-col border-l">
                            <div class="h-3 bg-gray-100 dark:bg-gray-800">
                                <div
                                        class="mr-1.5 flex h-full items-center justify-end"
                                >
                                    <div
                                            class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                    <div
                                            class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                    <div
                                            class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                </div>
                            </div>
                            <div
                                    class="flex flex-auto border-t bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                            [class.text-primary]="config.layout === 'futuristic'"
                            class="text-secondary mt-2 text-center text-md font-medium"
                    >
                        Futuristic
                    </div>
                </div>

                <!-- Thin -->
                <div
                        (click)="setLayout('thin')"
                        class="flex cursor-pointer flex-col"
                >
                    <div
                            [class.border-primary]="config.layout === 'thin'"
                            class="flex h-20 overflow-hidden rounded-md border-2 hover:opacity-80"
                    >
                        <div class="w-3 bg-gray-100 dark:bg-gray-800">
                            <div
                                    class="mx-auto mt-2 h-1.5 w-1.5 rounded-sm bg-gray-300 dark:bg-gray-700"
                            ></div>
                            <div
                                    class="mt-2 flex w-full flex-col items-center space-y-1"
                            >
                                <div
                                        class="h-1.5 w-1.5 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1.5 w-1.5 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1.5 w-1.5 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1.5 w-1.5 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1.5 w-1.5 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                            </div>
                        </div>
                        <div class="flex flex-auto flex-col border-l">
                            <div class="h-3 bg-gray-100 dark:bg-gray-800">
                                <div
                                        class="mr-1.5 flex h-full items-center justify-end"
                                >
                                    <div
                                            class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                    <div
                                            class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                    <div
                                            class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                </div>
                            </div>
                            <div
                                    class="flex flex-auto border-t bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                            [class.text-primary]="config.layout === 'thin'"
                            class="text-secondary mt-2 text-center text-md font-medium"
                    >
                        Thin
                    </div>
                </div>
            </div>

            <div class="my-10 text-secondary text-md font-semibold">
                Horizontal Layout
            </div>
            <div class="grid grid-cols-3 gap-3">
                <!-- Centered -->
                <div
                        (click)="setLayout('centered')"
                        class="flex cursor-pointer flex-col"
                >
                    <div
                            [class.border-primary]="config.layout === 'centered'"
                            class="flex h-20 overflow-hidden rounded-md border-2 hover:opacity-80"
                    >
                        <div
                                class="mx-2 my-1 flex flex-auto flex-col overflow-hidden rounded-md border"
                        >
                            <div
                                    class="flex h-3 items-center bg-gray-100 dark:bg-gray-800"
                            >
                                <div class="ml-1.5 flex">
                                    <div
                                            class="h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                    <div
                                            class="ml-1 h-1 w-3 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                    <div
                                            class="ml-1 h-1 w-3 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                    <div
                                            class="ml-1 h-1 w-3 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                </div>
                                <div
                                        class="ml-auto mr-1.5 flex items-center justify-end"
                                >
                                    <div
                                            class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                    <div
                                            class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                </div>
                            </div>
                            <div
                                    class="flex flex-auto border-t bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                            [class.text-primary]="config.layout === 'centered'"
                            class="text-secondary mt-2 text-center text-md font-medium"
                    >
                        Centered
                    </div>
                </div>

                <!-- Enterprise -->
                <div
                        (click)="setLayout('enterprise')"
                        class="flex cursor-pointer flex-col"
                >
                    <div
                            [class.border-primary]="config.layout === 'enterprise'"
                            class="flex h-20 flex-col overflow-hidden rounded-md border-2 hover:opacity-80"
                    >
                        <div
                                class="flex h-3 items-center bg-gray-100 px-2 dark:bg-gray-800"
                        >
                            <div
                                    class="h-2 w-2 rounded-full bg-gray-300 dark:bg-gray-700"
                            ></div>
                            <div
                                    class="ml-auto flex items-center justify-end space-x-1"
                            >
                                <div
                                        class="h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                            </div>
                        </div>
                        <div
                                class="flex h-3 items-center space-x-1 border-b border-t bg-gray-100 px-2 dark:bg-gray-800"
                        >
                            <div
                                    class="h-1 w-3 rounded-full bg-gray-300 dark:bg-gray-700"
                            ></div>
                            <div
                                    class="h-1 w-3 rounded-full bg-gray-300 dark:bg-gray-700"
                            ></div>
                            <div
                                    class="h-1 w-3 rounded-full bg-gray-300 dark:bg-gray-700"
                            ></div>
                            <div
                                    class="h-1 w-3 rounded-full bg-gray-300 dark:bg-gray-700"
                            ></div>
                        </div>
                        <div
                                class="mx-2 my-1 flex flex-auto flex-col overflow-hidden rounded border"
                        >
                            <div
                                    class="flex flex-auto bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                            [class.text-primary]="config.layout === 'enterprise'"
                            class="text-secondary mt-2 text-center text-md font-medium"
                    >
                        Enterprise
                    </div>
                </div>

                <!-- Material -->
                <div
                        (click)="setLayout('material')"
                        class="flex cursor-pointer flex-col"
                >
                    <div
                            [class.border-primary]="config.layout === 'material'"
                            class="flex h-20 flex-col overflow-hidden rounded-md border-2 hover:opacity-80"
                    >
                        <div
                                class="mx-2 my-1 flex flex-auto flex-col overflow-hidden rounded border"
                        >
                            <div
                                    class="flex h-4 items-center bg-gray-100 px-2 dark:bg-gray-800"
                            >
                                <div
                                        class="h-2 w-2 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="ml-auto flex items-center justify-end space-x-1"
                                >
                                    <div
                                            class="h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                    <div
                                            class="h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                    <div
                                            class="h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                </div>
                            </div>
                            <div
                                    class="flex h-2 items-center space-x-1 bg-gray-100 px-2 dark:bg-gray-800"
                            >
                                <div
                                        class="h-1 w-3 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1 w-3 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1 w-3 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1 w-3 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                            </div>
                            <div
                                    class="flex flex-auto border-t bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                            [class.text-primary]="config.layout === 'material'"
                            class="text-secondary mt-2 text-center text-md font-medium"
                    >
                        Material
                    </div>
                </div>

                <!-- Modern -->
                <div
                        (click)="setLayout('modern')"
                        class="flex cursor-pointer flex-col"
                >
                    <div
                            [class.border-primary]="config.layout === 'modern'"
                            class="flex h-20 flex-col overflow-hidden rounded-md border-2 hover:opacity-80"
                    >
                        <div
                                class="flex h-4 items-center border-b bg-gray-100 px-2 dark:bg-gray-800"
                        >
                            <div
                                    class="h-2 w-2 rounded-full bg-gray-300 dark:bg-gray-700"
                            ></div>
                            <div class="ml-2 flex h-3 items-center space-x-1">
                                <div
                                        class="h-1 w-3 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1 w-3 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1 w-3 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                            </div>
                            <div
                                    class="ml-auto flex items-center justify-end space-x-1"
                            >
                                <div
                                        class="h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                        class="h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                            </div>
                        </div>
                        <div class="flex flex-auto flex-col">
                            <div
                                    class="flex flex-auto bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                            [class.text-primary]="config.layout === 'modern'"
                            class="text-secondary mt-2 text-center text-md font-medium"
                    >
                        Modern
                    </div>
                </div>
            </div>
        </div>
    </div>
</fuse-drawer>
